import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import ApfListaSelecaoPanel from "./apfListaSelecaoPanel";
import "./admPatrocinadoresList.css";
import "./admFormPatrocinadores.css";

const ListaSelecaoPatrocinador = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  return (
    <div className="container-adm-main">
      <div className="apl-page apl-page--wide-form">
        <header className="apl-header" aria-label="Lista de seleção">
          <div className="apl-header-text">
            <h1>Lista de seleção</h1>
            <p>Participantes escolhidos pelo patrocinador para reuniões.</p>
          </div>
          <div className="apl-toolbar">
            <button
              type="button"
              className="apl-btn apl-btn--ghost"
              onClick={() => navigate(-1)}
            >
              <FaArrowLeft size={14} aria-hidden />
              Voltar
            </button>
          </div>
        </header>

        <div className="body-tela-adm" style={{ paddingBottom: 0 }}>
          <section className="apl-card apf-form-card" aria-label="Seleções">
            {id ? (
              <ApfListaSelecaoPanel idPatrocinador={id} />
            ) : (
              <p className="small text-muted mb-0">
                Identificador do patrocinador não informado.
              </p>
            )}
          </section>
        </div>
      </div>
    </div>
  );
};

export default ListaSelecaoPatrocinador;
